<template>
    <div class="mine-page">
        <p>这是隐私条款页面</p>
    </div>
</template>

<script>
export default {
    name: 'PrivacyView',
    computed: {

    }
};
</script>

<style scoped>
.mine-page {
    padding: 20px;
    min-height: calc(100vh - 50px); /* 减去底部导航高度 */
}
</style>
